module.exports = __webpack_public_path__ + "static/media/visible.832b53f0.svg";